import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiertigacab() {



const cardData = {
  keyword: " Pune to Mumbai Ertiga Cab  ",

headingDescription:
  "Velocity Cab provides Pune to Mumbai Ertiga cab services, offering a comfortable and spacious travel experience for families, groups, and corporate travelers. Our professional drivers, well-maintained Maruti Ertiga vehicles, and punctual pickups ensure a smooth and stress-free journey from Pune to Mumbai. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Pune to Mumbai travel in an Ertiga.",

topPlaces: [
  {
    title: "Flora Fountain",
    description: "Flora Fountain is a magnificent Victorian monument located in the heart of South Mumbai and surrounded by heritage buildings and bustling business districts. Travelers booking an Innova Crysta on rent in Pune can comfortably explore this iconic landmark while visiting nearby shopping streets, cafés, and colonial-era architecture. It is a great destination for history enthusiasts, photographers, and anyone interested in Mumbai's rich heritage."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive is one of Mumbai's most scenic waterfront promenades, offering breathtaking views of the Arabian Sea and the city's skyline. Visitors choosing an Innova Crysta on rent in Pune can enjoy a comfortable road trip before relaxing by the coastline, taking evening walks, and witnessing the famous sunset that makes Marine Drive one of Mumbai's top attractions."
  },
  {
    title: "Film City, Goregaon",
    description: "Film City in Goregaon is the center of India's entertainment industry and home to numerous Bollywood movie and television sets. Renting an Innova Crysta in Pune makes the journey convenient for families and groups interested in guided studio tours, film sets, and behind-the-scenes experiences of India's vibrant film industry."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's most vibrant shopping destinations, offering fashion accessories, handicrafts, antiques, cafés, and street food. Travelers hiring an Innova Crysta on rent in Pune can comfortably explore this lively market while enjoying local shopping and discovering the charm of South Mumbai."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is a vast green oasis within Mumbai, famous for its wildlife, cycling trails, boating, and lush forests. Booking an Innova Crysta on rent in Pune ensures a comfortable drive to this natural attraction, making it an excellent destination for families, adventure lovers, and nature enthusiasts."
  },
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens on Malabar Hill are beautifully landscaped terraced gardens offering panoramic views of the Arabian Sea and Marine Drive. Travelers choosing an Innova Crysta on rent in Pune can relax amidst well-maintained greenery, unique topiary displays, and peaceful surroundings while enjoying one of Mumbai's most scenic viewpoints."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is among Mumbai's most popular coastal attractions, known for its lively atmosphere, delicious street food, and spectacular sunsets. Visitors renting an Innova Crysta in Pune can comfortably travel to Mumbai and spend quality time enjoying beach walks, local snacks, and family-friendly entertainment."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is a remarkable meditation monument featuring one of the world's largest stone domes. Travelers booking an Innova Crysta on rent in Pune can enjoy a scenic drive to this peaceful destination near Gorai and experience meditation, spiritual learning, and impressive architecture surrounded by serene landscapes."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a picturesque urban lake surrounded by gardens, restaurants, and modern city landmarks. Hiring an Innova Crysta on rent in Pune provides a smooth journey for families and groups looking to enjoy lakeside views, peaceful walks, boating, and quality leisure time in one of Mumbai's most attractive neighborhoods."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most iconic historical monument overlooking the Arabian Sea. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this famous landmark, admire its magnificent architecture, enjoy ferry rides to nearby attractions, and capture unforgettable photographs at one of India's most recognized tourist destinations."
  }
],



services: [
{
name: "Ertiga Per Km Rate in Pune",
description: "Ertiga per km rate in Pune service provides transparent pricing for travelers planning SUV taxi rides for city travel and outstation trips. The Ertiga vehicle offers comfortable seating for up to 6–7 passengers, making it ideal for family travel and airport transfers. Professional drivers ensure safe driving and punctual pickup services across Pune."
},
{
name: "Pune to Mumbai Airport Ertiga Cab",
description: "Pune to Mumbai Airport Ertiga cab service offers reliable airport transportation using spacious 7-seater SUVs. The Ertiga vehicle provides comfortable seating and luggage space suitable for airport travel. Professional drivers ensure safe expressway travel and timely drop at Mumbai Airport terminals."
},
{
name: "Pune to Dadar Ertiga Cab Fare",
description: "Pune to Dadar Ertiga cab fare service provides clear pricing for passengers traveling between Pune and Dadar in Mumbai. The Ertiga SUV offers comfortable seating for families and small groups. Professional drivers ensure safe driving through the Mumbai–Pune Expressway."
},
{
name: "Pune to Andheri Ertiga Taxi Fare",
description: "Pune to Andheri Ertiga taxi fare services provide cost estimates for travelers planning SUV taxi rides between Pune and Andheri in Mumbai. The Ertiga vehicle ensures spacious seating and smooth highway travel."
},
{
name: "Pune to Mumbai One Way Ertiga Taxi Cab",
description: "Pune to Mumbai one way Ertiga taxi cab service offers convenient single-trip transportation between Pune and Mumbai. The Ertiga vehicle provides spacious seating suitable for family trips and corporate travel."
},
{
name: "Ertiga Cab in Pune",
description: "Ertiga cab in Pune service offers comfortable 7-seater SUV transportation for city rides, airport transfers, and outstation journeys. Vehicles are well maintained and driven by professional drivers ensuring safe travel."
},
{
name: "Ertiga Cab for Mumbai Airport Drop",
description: "Ertiga cab for Mumbai Airport drop provides reliable transportation from Pune to Mumbai Airport. The spacious SUV offers comfortable seating and luggage space suitable for airport transfers."
},
{
name: "Viman Nagar to Mumbai Cabs",
description: "Viman Nagar to Mumbai cab service provides dependable transportation between Pune’s Viman Nagar area and Mumbai city. Comfortable vehicles and professional drivers ensure safe expressway journeys."
},
{
name: "Wagholi to Mumbai Cab Service",
description: "Wagholi to Mumbai cab service offers reliable transportation between Wagholi in Pune and Mumbai city. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys."
},
{
name: "Pune to Borivali Ertiga Cab",
description: "Pune to Borivali Ertiga cab service offers spacious SUV transportation between Pune and Borivali in Mumbai. The Ertiga vehicle provides comfortable seating suitable for long-distance highway travel."
},
{
name: "Pune to Andheri Ertiga Cab",
description: "Pune to Andheri Ertiga cab service provides dependable transportation between Pune and Andheri in Mumbai. The spacious SUV ensures comfortable expressway travel with professional drivers."
},
{
name: "Pune to Dadar Ertiga Cab",
description: "Pune to Dadar Ertiga cab service offers comfortable SUV transportation between Pune and Mumbai’s Dadar area. The vehicle is suitable for families and small groups traveling via the expressway."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service provides spacious SUV transportation between Pune and Mumbai. The Ertiga vehicle offers comfortable seating, luggage capacity, and smooth highway travel."
},
{
name: "Pune to Mumbai 7 Seater Cab",
description: "Pune to Mumbai 7 seater cab service offers comfortable SUV travel for families and groups. Vehicles like Ertiga provide spacious seating and luggage space suitable for long-distance expressway travel."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip service provides convenient travel options for passengers planning same-day or multi-day return journeys. Comfortable vehicles ensure smooth highway travel with professional drivers."
},
{
name: "Pune to Mumbai Airport Ertiga Cab",
description: "Pune to Mumbai Airport Ertiga cab service provides reliable airport transportation using spacious SUVs. The vehicle ensures comfortable seating and luggage space for airport travelers."
},
{
name: "Pune to Mumbai Central Cab",
description: "Pune to Mumbai Central cab service offers dependable transportation for travelers heading to Mumbai Central railway station. Vehicles are comfortable and suitable for expressway travel."
},
{
name: "Ertiga on Rent in Pune",
description: "Ertiga on rent in Pune offers comfortable SUV rental for city rides, airport transfers, and outstation trips. The 7-seater vehicle provides spacious seating ideal for family travel and group journeys."
},
{
name: "Pune to Mumbai Darshan Ertiga on Rent",
description: "Pune to Mumbai darshan Ertiga on rent service offers sightseeing travel options for visitors planning to explore famous locations in Mumbai. Comfortable SUVs ensure smooth and safe city tours."
},
{
name: "Velocity Cabs Pune",
description: "Velocity Cabs Pune offers reliable transportation services for local rides, airport transfers, and outstation travel. Comfortable vehicles and professional drivers ensure safe and convenient journeys."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides dependable transportation for local travel, airport transfers, and outstation journeys. Vehicles are comfortable and suitable for city and highway travel."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service offers reliable airport transportation between Pune and Mumbai Airport terminals. Comfortable vehicles ensure smooth expressway travel with professional drivers."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service provides dependable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for highway travel with experienced drivers."
},
{
name: "Ertiga Hire in Pune for Outstation",
description: "Ertiga hire in Pune for outstation service offers comfortable SUV transportation for travelers planning long-distance journeys from Pune to nearby cities. The vehicle provides spacious seating suitable for families."
},
{
name: "Pune to Mumbai Ertiga Taxi",
description: "Pune to Mumbai Ertiga taxi service provides comfortable SUV transportation for passengers traveling between Pune and Mumbai. The vehicle offers smooth highway travel with spacious seating."
},
{
name: "Pune to Mumbai Ertiga Cab Service",
description: "Pune to Mumbai Ertiga cab service offers reliable SUV transportation between Pune and Mumbai with professional drivers ensuring safe expressway travel."
}
],

tableData: [
["Ertiga Per Km Rate in Pune","Pune to Mumbai Airport Ertiga Cab"],
["Pune to Dadar Ertiga Cab Fare","Pune to Andheri Ertiga Taxi Fare"],
["Pune to Mumbai One Way Ertiga Taxi Cab","Ertiga Cab in Pune"],
["Ertiga Cab for Mumbai Airport Drop","Viman Nagar to Mumbai Cabs"],
["Wagholi to Mumbai Cab Service","Pune to Borivali Ertiga Cab"],
["Pune to Andheri Ertiga Cab","Pune to Dadar Ertiga Cab"],
["Pune to Mumbai Ertiga Cab","Pune to Mumbai 7 Seater Cab"],
["Pune to Mumbai Cab Round Trip","Pune to Mumbai Airport Ertiga Cab"],
["Pune to Mumbai Central Cab","Ertiga on Rent in Pune"],
["Pune to Mumbai Darshan Ertiga on Rent","Velocity Cabs Pune"],
["Cab Service in Pune","Pune to Mumbai Airport Cab"],
["Pune Mumbai Cab","Ertiga Hire in Pune for Outstation"],
["Pune to Mumbai Ertiga Taxi","Pune to Mumbai Ertiga Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Ertiga Intercity Travel",
    WhyChoosedescription: "Velocity Cabs offers spacious and comfortable Maruti Ertiga cabs for Pune to Mumbai travel. The vehicle is perfect for families and small groups who want a smooth and relaxing highway journey."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides professional drivers who regularly travel between Pune and Mumbai via the Mumbai Pune Expressway. Their experience ensures safe driving and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Ertiga Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers clear and transparent pricing for Pune to Mumbai Ertiga cab bookings. Customers receive full fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Pune to Mumbai Ertiga cab service operates 24 hours a day. Whether you need a late-night ride, airport transfer, or early morning travel, Velocity Cabs ensures reliable transportation."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Ertiga Vehicles",
    WhyChoosedescription: "All Ertiga vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Perfect for Family & Group Travel",
    WhyChoosedescription: "The Ertiga cab is ideal for families and small groups traveling from Pune to Mumbai. With spacious seating and luggage capacity, it offers a comfortable ride for long-distance journeys."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "Velocity Cabs provides doorstep pickup from homes, hotels, offices, and railway stations across Pune including Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, and Viman Nagar."
  },
  {
    WhyChooseheading: "Trusted Pune Mumbai Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Pune to Mumbai Ertiga cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Pune to Mumbai Ertiga cab service?", answer: "Yes, Velocity Cabs provides comfortable and spacious Ertiga cab services from Pune to Mumbai." },
  { question: "How many passengers can travel in an Ertiga cab?", answer: "An Ertiga cab can comfortably accommodate up to 6 passengers along with luggage." },
  { question: "Is Pune to Mumbai Ertiga cab service available 24 hours?", answer: "Yes, our Ertiga cab service operates 24/7 for intercity travel." },
  { question: "Can I book a one-way Ertiga cab from Pune to Mumbai?", answer: "Yes, Velocity Cabs provides both one-way and round-trip Ertiga cab services between Pune and Mumbai." },
  { question: "Do you provide pickup from Pune Airport or railway station?", answer: "Yes, our drivers provide pickup from Pune Airport, railway stations, homes, offices, and hotels across Pune." },
  { question: "Are Ertiga vehicles air-conditioned?", answer: "Yes, all Ertiga vehicles provided by Velocity Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book Pune to Mumbai Ertiga cab online?", answer: "Yes, customers can easily book Ertiga cabs online or through phone booking with Velocity Cabs." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide Mumbai Airport drop?", answer: "Yes, Velocity Cabs provides direct drop service to Mumbai Airport and other locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "A very comfortable Pune to Mumbai journey in an Ertiga cab. The vehicle was spacious, clean, and perfect for a smooth highway ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Ertiga cab from Pune to Mumbai was an excellent choice for family travel. The ride was steady, comfortable, and the overall experience felt very safe and well-managed.",
    rating: 5
  }
];






































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Ertiga Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides Pune to Mumbai Ertiga cab service with affordable fares and professional drivers. Book one way and round trip Ertiga taxis for airport transfers, Dadar, Andheri, Borivali, Viman Nagar, Wagholi, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Pune to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};



  return (
    <div>
      

<Helmet>
  <title>Pune to Mumbai Ertiga Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Ertiga cab with Velocity Cabs. Affordable one way, round trip & airport drop Ertiga taxis for Dadar, Andheri, Borivali, Viman Nagar & Wagholi. Safe and reliable cab service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiertigacab;